import { render, staticRenderFns } from "./LinkUnderlined.vue?vue&type=template&id=0ce469cc&scoped=true&"
import script from "./LinkUnderlined.vue?vue&type=script&lang=js&"
export * from "./LinkUnderlined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce469cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VSubheader})
